export default function getHttpError(error: any) {
  // fixme: разобраться с ошибками и раскоментить/ сейчас в логах ничего не видно
  // console.trace(error?.response?.statusText);

  if (error?.response?.data?.error?.message) {
    return { err: error.response.data.error.message };
  }

  return { err: error.message };
}
